export default [
  [
    {
      title: 'UBC Aquatic Centre',
      loc: [49.2673754, -123.2510018],
    },
    {
      title: 'War Memorial Gymnasium',
      loc: [49.2662973, -123.2487876],
    },
    {
      title: 'Doug Mitchell Thunderbird Sports Centre',
      loc: [49.2605684, -123.243601],
    },
    {
      title: 'Thunderbird Stadium',
      loc: [49.2544382, -123.2477138],
    },
    {
      title: 'University Golf Club',
      loc: [49.2647101, -123.2299733],
    },
    {
      title: 'UBC Hospital',
      loc: [49.2626172, -123.2198622],
    },
    {
      title: 'Gerald McGavin Rugby Centre',
      loc: [49.2595627, -123.2435543],
    },
    {
      title: 'UBC BodyWorks Fitness Centre',
      loc: [49.260009, -123.2464309],
    },
    {
      title: 'UBC Tennis Centre',
      loc: [49.259775, -123.2453258],
    },
    {
      title: 'Tower Beach',
      loc: [49.2725123, -123.2614838],
    },
  ],
  [
    {
      title: 'Nitobe Memorial Garden',
      loc: [49.2663522, -123.2618527],
    },
    {
      title: 'Museum of Anthropology',
      loc: [49.269436, -123.2610387],
    },
    {
      title: 'UBC Botanical Garden and Centre for Plant Research',
      loc: [49.2538917, -123.2532645],
    },
    {
      title: 'Chan Centre for the Performing Arts',
      loc: [49.2696858, -123.2573174],
    },
    {
      title: 'Walter C. Koerner Library',
      loc: [49.2666531, -123.2573057],
    },
    {
      title: 'GEERing Up! UBC Engineering & Science for kids',
      loc: [49.2626019, -123.2500697],
    },
    {
      title: 'Beaty Biodiversity Museum',
      loc: [49.263268, -123.2531564],
    },
    {
      title: 'Frederic Wood Theatre',
      loc: [49.2680432, -123.2592098],
    },
    {
      title: 'Morris and Helen Belkin Art Gallery',
      loc: [49.268245, -123.2584897],
    },
    {
      title: 'UBC Bookstore',
      loc: [49.26507, -123.2527607],
    },
  ],
  [
    {
      title: 'Mahony & Sons Public House',
      loc: [49.2734964, -123.2541297],
    },
    {
      title: "Vera's Burger Shack",
      loc: [49.2673657, -123.2632607],
    },
    {
      title: 'Booster Juice',
      loc: [49.2674179, -123.2458011],
    },
    {
      title: "McDonald's",
      loc: [49.2644276, -123.2467735],
    },
    {
      title: 'One More Sushi',
      loc: [49.2660736, -123.2448492],
    },
    {
      title: 'Beanery Coffee House',
      loc: [49.2724366, -123.2445838],
    },
    {
      title: 'The Pit',
      loc: [49.2666285, -123.2525217],
    },
    {
      title: 'Sage Bistro',
      loc: [49.2689235, -123.2593955],
    },
    {
      title: 'The Point Grill',
      loc: [49.2616027, -123.2574626],
    },
    {
      title: 'Tim Hortons',
      loc: [49.2588648, -123.2509136],
    },
    {
      title: 'Pizza Garden',
      loc: [49.266834, -123.2461855],
    },
    {
      title: 'Red Burrito',
      loc: [49.265065, -123.2481051],
    },
  ],
  [
    {
      title: 'Royal Canadian Mounted Police & Firehall',
      loc: [49.2580304, -123.2555915],
    },
    {
      title: 'UBC Child Care Services',
      loc: [49.261161, -123.236459],
    },
    {
      title: 'AMS Student Nest',
      loc: [49.266601, -123.2520467],
    },
    {
      title: 'Bank of Montreal',
      loc: [49.2670813, -123.2465517],
    },
    {
      title: 'Shoppers Drug Mart',
      loc: [49.2572519, -123.2401715],
    },
    {
      title: 'Shoppers Drug Mart',
      loc: [49.2629565, -123.2470457],
    },
    {
      title: 'Staples Business Depot',
      loc: [49.2654728, -123.2557729],
    },
    {
      title: 'The Old Barn Community Centre',
      loc: [49.2590064, -123.2506237],
    },
  ],
  [
    {
      title: 'University Hill Elementary School',
      loc: [49.2695445, -123.2415526],
    },
    {
      title: 'Queen Mary Elementary',
      loc: [49.2680915, -123.2072743],
    },
    {
      title: 'Queen Elizabeth Annex',
      loc: [49.248888, -123.1962938],
    },
    {
      title: 'Jules Quesnel Elementary',
      loc: [49.2594424, -123.1956455],
    },
    {
      title: 'Southlands Elementary',
      loc: [49.2381428, -123.1998413],
    },
    {
      title: 'Bayview Elementary',
      loc: [49.2664497, -123.1844212],
    },
    {
      title: 'Lord Kitchener Elementary',
      loc: [49.2505519, -123.1831728],
    },
    {
      title: 'Trafalgar Elementary',
      loc: [49.2496749, -123.1666578],
    },
    {
      title: 'Norma Rose Point Elementary',
      loc: [49.2616682, -123.2344323],
    },
    {
      title: 'University Hill Secondary',
      loc: [49.2539758, -123.2420516],
    },
    {
      title: 'Lord Bying Secondary',
      loc: [49.2585212, -123.1942852],
    },
    {
      title: 'Kitsilano Secondary',
      loc: [49.262206, -123.1664967],
    },
    {
      title: 'Prince of Wales Secondary',
      loc: [49.2455558, -123.1597526],
    },
    {
      title: 'Point Grey Secondary',
      loc: [49.2374547, -123.1551436],
    },
    {
      title: 'Magee Secondary',
      loc: [49.2288012, -123.1538842],
    },
    {
      title: 'Eaton Arrowsmith School',
      loc: [49.2610349, -123.2483911],
    },
    {
      title: 'West Point Grey Academy',
      loc: [49.2665672, -123.2025008],
    },
    {
      title: 'Our Lady of Perpetual Help School',
      loc: [49.2640933, -123.1986231],
    },
    {
      title: "St. George's School Senior Campus",
      loc: [49.2475246, -123.2013431],
    },
    {
      title: "St. George's School Junior Campus",
      loc: [49.2471611, -123.1917457],
    },
    {
      title: 'St. Augustine School',
      loc: [49.2653424, -123.1556178],
    },
    {
      title: 'Crofton House School',
      loc: [49.2344415, -123.1791002],
    },
    {
      title: 'York House School',
      loc: [49.2489053, -123.1433611],
    },
    {
      title: 'Little Flower Academy',
      loc: [49.2482546, -123.1441608],
    },
  ],
];



// WEBPACK FOOTER //
// ./src/data/map.js